import { loadStripe } from '@stripe/stripe-js';

export const useStripeKey = () => {
  const stripePromise = loadStripe(process.env.GATSBY_STRIPE_PUBLISHABLE_KEY)
  return stripePromise
}